export const locale = {
  required_message: 'Cannot be left blank. ',
};
